import { DentalOfficeShiftCard } from '@tempmee/react-blocks';
import { InviteProfessionalPopup } from '~/commonComponents/InviteProfessional/Popup';
import {
  type IShiftOverviewCardProps,
  useShiftOverviewCard,
} from './useShiftOverviewCard';

export const ShiftOverviewCard = (props: IShiftOverviewCardProps) => {
  const { item, onCardClick, invite } = props;
  const {
    cardData,
    handleInvite,
    menuItems,
    isInvitePopupOpen,
    closeInvitePopup,
    cancelPopup,
  } = useShiftOverviewCard(props);

  return (
    <>
      <DentalOfficeShiftCard
        {...cardData}
        onMessage={handleInvite}
        menuItems={menuItems}
        onCardClick={() => onCardClick(item)}
        data-cy="shift-overview-card"
      />

      {isInvitePopupOpen && (
        <InviteProfessionalPopup
          isOpen={isInvitePopupOpen}
          isRefetchJob
          jobId={item.id}
          profession={item.dashboardJobApi?.profession}
          officeId={item.office?.id}
          onClose={closeInvitePopup}
          trackingSource={invite?.trackingSource}
        />
      )}

      {cancelPopup}
    </>
  );
};
